(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-set"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('barrely-set')) {
  customElements.define('barrely-set', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.button = this.querySelector('[data-submit]');
      if (!this.button) return;
      this.message = this.querySelector('[data-message]');
      this.addEventListener('change', (event) => {
        if (event.target?.matches?.('[data-bs-swatch]')) {
          const targetId = event.target.dataset.target;
          const targetSelect = targetId ? this.querySelector(`#${CSS.escape(targetId)}`) : null;

          if (targetSelect) {
            targetSelect.value = event.target.value;
          }

          const colorControl = event.target.closest('.bs-color-control');
          const colorName = colorControl?.querySelector('[data-bs-color-name]');

          if (colorName) {
            colorName.textContent = event.target.dataset.colorName || '';
          }
        }

        this.update();
      }, { signal: this.controller.signal });

      if (this.dataset.followProduct === 'true') {
        const syncFromForm = (event) => {
          const main = event.target.closest?.('product-info[id^="MainProduct--"]');
          if (main?.dataset.productId === this.dataset.productId && event.target.matches('input[name="id"]')) {
            this.syncBase(event.target.value);
          }
        };
        document.addEventListener('change', syncFromForm, { signal: this.controller.signal });
        document.addEventListener('theme:product-info:loaded', () => this.syncFromProduct(), { signal: this.controller.signal });
        if (typeof subscribe === 'function' && window.theme?.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribeVariant = subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const main = document.querySelector('product-info[id^="MainProduct--"]');
            if (main?.dataset.productId === this.dataset.productId && data.sectionId === main.dataset.section) {
              this.syncBase(data.variant?.id || '');
            }
          });
        }
        this.syncFromProduct();
      }
      this.button.addEventListener('click', () => this.add(), { signal: this.controller.signal });
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribeVariant?.();
      this.unsubscribeVariant = null;
      this.controller = null;
    }
    syncFromProduct() {
      const main = document.querySelector('product-info[id^="MainProduct--"]');
      if (main?.dataset.productId !== this.dataset.productId) return;
      const input = main.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input) this.syncBase(input.value);
    }
    syncBase(id) {
      const base = this.querySelector('[data-base]');
      if (!base) return;
      const option = Array.from(base.options).find(item => item.value === String(id));
      base.value = option ? option.value : '';
      this.update();
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
    }
    selection() {
      const base = this.querySelector('[data-base]');
      const choice = this.querySelector('.bs-radio:checked')?.closest('[data-choice]').querySelector('select');
      return [base, choice];
    }
    valid(select) { return select && !select.disabled && select.selectedOptions[0] && !select.selectedOptions[0].disabled; }
    normalise(value) {
      const name = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      return name === 'matchagreen' ? 'matcha' : name;
    }
    quote(row) {
      const base = this.querySelector('[data-base]')?.selectedOptions[0];
      const option = row.querySelector('select')?.selectedOptions[0];
      if (!base || !option) return null;
      const basePrice = Number(base.dataset.price);
      const originalPrice = Number(option.dataset.price);
      const nativeData = row.querySelector('[data-native-bundle]');
      if (nativeData) {
        const variants = JSON.parse(nativeData.textContent);
        const baseIndex = Number(row.dataset.nativeBaseOption || 1) - 1;
        const addonIndex = baseIndex === 0 ? 1 : 0;
        const variant = variants.find(item => this.normalise(item.options[baseIndex]) === this.normalise(base.dataset.title) && this.normalise(item.options[addonIndex]) === this.normalise(option.dataset.title));
        return { originalPrice, price: variant ? Math.max(0, variant.price - basePrice) : originalPrice, total: variant?.price, available: Boolean(variant?.available), nativeId: variant?.id };
      }
      const savings = Math.max(0, Number(row.dataset.pairSavings || 0));
      const manual = Number(row.dataset.discountedCents || 0);
      const price = savings > 0 ? Math.max(0, originalPrice - savings) : manual > 0 && manual < originalPrice ? manual : originalPrice;
      return { originalPrice, price, total: basePrice + price, available: !option.disabled };
    }
    update() {
      const baseOption = this.querySelector('[data-base]')?.selectedOptions[0];
      const baseName = this.querySelector('[data-base-name]');
      if (baseName) baseName.textContent = baseOption?.dataset.title || this.dataset.unavailable;
      const baseImage = this.querySelector('.bs-base-row .bs-image');
      if (baseImage && baseOption?.dataset.image && baseImage.getAttribute('src') !== baseOption.dataset.image) {
        baseImage.removeAttribute('srcset');
        baseImage.src = baseOption.dataset.image;
      }
      const basePriceEl = this.querySelector('.bs-base-row [data-price]');
      if (basePriceEl && baseOption) basePriceEl.textContent = this.money(Number(baseOption.dataset.price));
      this.querySelectorAll('[data-choice]').forEach(row => {
        row.querySelector('.bs-options').hidden = !row.querySelector('.bs-radio').checked;
        const quote = this.quote(row);
        if (!quote) return;
        const hasDiscount = quote.price < quote.originalPrice && quote.available;
        row.querySelector('[data-price]').textContent = this.money(hasDiscount ? quote.price : quote.originalPrice);
        const original = row.querySelector('[data-original-price]');
        original.textContent = this.money(quote.originalPrice);
        original.hidden = !hasDiscount;
        row.querySelector('.bs-item-prices').classList.toggle('has-discount', hasDiscount);
      });
      const [base, choice] = this.selection();
      const quote = choice ? this.quote(choice.closest('[data-choice]')) : null;
      const ready = this.valid(base) && this.valid(choice) && quote?.available;
      this.button.disabled = !ready || this.busy;
      if (this.dataset.compact === 'true') this.querySelector('.bs-total').hidden = !ready;
      const compareEl = this.querySelector('[data-compare-total]');
      const savingsEl = this.querySelector('[data-savings]');
      const totalEl = this.querySelector('[data-total]');
      if (ready) {
        const compareTotal = Number(base.selectedOptions[0].dataset.price) + quote.originalPrice;
        totalEl.textContent = this.money(quote.total);
        const savings = compareTotal - quote.total;
        compareEl.hidden = savings <= 0;
        savingsEl.hidden = savings <= 0;
        if (savings > 0) {
          compareEl.textContent = this.money(compareTotal);
          this.querySelector('[data-savings-amount]').textContent = this.money(savings);
        }
      } else {
        totalEl.textContent = '—';
        compareEl.hidden = true;
        savingsEl.hidden = true;
      }
      this.message.textContent = !this.valid(base) || (choice && !quote?.available) ? this.dataset.unavailable : ready ? '' : this.dataset.prompt;
    }
    async add() {
      if (this.busy) return;
      const selects = this.selection();
      if (!selects.every(select => this.valid(select))) return;
      const quote = this.quote(selects[1].closest('[data-choice]'));
      if (!quote?.available) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.loading;
      this.message.textContent = '';
      try {
        const items = quote.nativeId ? [{ id: quote.nativeId, quantity: 1 }] : selects.map(select => ({ id: select.value, quantity: 1 }));
        const response = await fetch(this.dataset.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.busy = false;
        this.update();
        this.button.textContent = this.dataset.button;
        this.message.textContent = error.message || this.dataset.error;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
